import React from "react";
import { translate } from "../../../../../common/providers";
import styles from "./ProductTourHeader.module.css";
import HeaderRow from "./HeaderRow";

export default function ProductTourHeader({
	checkedAll,
	countChecked,
	currentCheckedList,
	currentList,
	onCheckAll,
	onOpenAssign,
}) {
	return (
		<div className={styles.header}>
			<HeaderRow
				isProductTour
				checkedAll={checkedAll}
				countChecked={countChecked}
				currentCheckedList={currentCheckedList}
				currentList={currentList}
				onCheckAll={onCheckAll}
				onOpenAssign={onOpenAssign}
			/>
			<div>{translate("common:company")}</div>
		</div>
	);
}
